import { gql } from '@apollo/client';

const UPDATE_PROJECT_PRODUCTS = gql`
    mutation UpdateProjectProducts($profileId: Int!, $projectId: Int!, $productIds: [Int]!) {
        updateProjectProducts(profileId: $profileId, projectId: $projectId, productIds: $productIds)
    }
`;

export default UPDATE_PROJECT_PRODUCTS;
